import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const HexaIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 19.5 21.952"
    >
      <g transform="translate(1 1)">
        <path
          d="M471.079,136.6l-8.91-5.081-8.59,5.081v10.161l8.759,4.71,8.741-5.047Z"
          transform="translate(-453.579 -131.524)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
